<app-social-shell active="communities">
      <a class="so-back" [routerLink]="slug ? ['/communities', slug] : ['/communities']">
        <i class="fa fa-arrow-left"></i> {{ slug ? (community?.name || 'Community') : 'Communities' }}
      </a>

      <div class="so-page-head">
        <div>
          <h1>{{ isEdit ? 'Community settings' : 'Create a community' }}</h1>
          <p>{{ isEdit ? 'Change how your community looks and who can join.' : 'A home for your group: post, plan sessions, invite people.' }}</p>
        </div>
      </div>

      @if (loading) {
        <div class="so-card so-card-pad"><span class="so-skel" style="height: 16px"></span><span class="so-skel" style="height: 16px; width: 60%; margin-top: 10px"></span></div>
      } @else if (notAllowed) {
        <div class="so-card cf-box">
          <p>Only this community's owner and moderators can change its settings.</p>
          <a class="btn btn-dark" [routerLink]="['/communities', slug]">Back to the community</a>
        </div>
      } @else {
        <form class="so-card cf-box" (ngSubmit)="save()" novalidate>
          <div class="cf-image-row">
            <div class="cf-image">
              @if (imagePreview) {
                <img [src]="imagePreview" alt="Community picture" />
              } @else {
                <i class="fa fa-users" aria-hidden="true"></i>
              }
            </div>
            <div class="cf-image-actions">
              <label class="btn btn-dark">
                {{ imagePreview ? 'Change picture' : 'Add a picture' }}
                <input type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden (change)="onImage($event)" />
              </label>
              @if (imagePreview) {
                <button type="button" class="cf-link" (click)="clearImage()">Remove</button>
              }
              <span class="cf-hint">Square works best. Up to 5MB.</span>
              @if (imageError) {
                <span class="cf-error">{{ imageError }}</span>
              }
            </div>
          </div>

          <label class="cf-field">
            <span>Name <span class="cf-req">*</span></span>
            <input type="text" name="name" maxlength="80" [(ngModel)]="name" placeholder="e.g. The Drowned Bell Players"
              [class.is-invalid]="submitted && nameError" />
            @if (submitted && nameError) {
              <span class="cf-error">{{ nameError }}</span>
            }
          </label>

          <label class="cf-field">
            <span>Short description</span>
            <textarea name="description" rows="2" maxlength="500" [(ngModel)]="description"
              placeholder="What is this community about?"></textarea>
            <span class="cf-hint">{{ description.length }}/500 · shown in the directory, even for private communities.</span>
          </label>

          <label class="cf-field">
            <span>Rules</span>
            <textarea name="rules" rows="4" maxlength="5000" [(ngModel)]="rules"
              placeholder="One per line, e.g. Be kind. No spoilers for current campaigns."></textarea>
          </label>

          <fieldset class="cf-field" [disabled]="!isOwner">
            <legend>Who can join</legend>
            <div class="cf-options">
              <label class="cf-option" [class.is-on]="privacy === 'public'">
                <input type="radio" name="privacy" value="public" [(ngModel)]="privacy" />
                <span class="cf-option-title"><i class="fa fa-globe"></i> Public</span>
                <span class="cf-option-text">Anyone can join and read posts.</span>
              </label>
              <label class="cf-option" [class.is-on]="privacy === 'private'">
                <input type="radio" name="privacy" value="private" [(ngModel)]="privacy" />
                <span class="cf-option-title"><i class="fa fa-lock"></i> Private</span>
                <span class="cf-option-text">People ask to join or are invited. Only members see posts.</span>
              </label>
            </div>
            @if (isEdit && community?.privacy === 'private' && privacy === 'public') {
              <span class="cf-hint cf-warn">Anyone waiting for approval will be let in when you save.</span>
            }
          </fieldset>

          <label class="cf-check" [class.is-disabled]="!isOwner">
            <input type="checkbox" name="membersCanInvite" [(ngModel)]="membersCanInvite" [disabled]="!isOwner" />
            <span>Members can invite people <span class="cf-hint">(the owner and moderators always can)</span></span>
          </label>
          @if (!isOwner) {
            <p class="cf-hint">Only the owner can change who can join or invite.</p>
          }

          @if (formError) {
            <p class="cf-error cf-form-error" role="alert">{{ formError }}</p>
          }

          <div class="cf-actions">
            <button type="button" class="btn btn-dark" (click)="cancel()">Cancel</button>
            <button type="submit" class="btn btn-theme" [disabled]="saving">
              {{ saving ? 'Saving…' : (isEdit ? 'Save changes' : 'Create community') }}
            </button>
          </div>
        </form>

        @if (isEdit && community?.my_role === 'owner') {
          <section class="so-card cf-box cf-danger">
            <h2>Delete community</h2>
            <p>Posts, members and invites go with it. This can't be undone. To hand it to someone else instead, use "Make owner" on the Members tab.</p>
            @if (!confirmDelete) {
              <button type="button" class="btn btn-dark cf-danger-btn" (click)="confirmDelete = true">Delete community…</button>
            } @else {
              <label class="cf-field">
                <span>Type <strong>{{ community?.name }}</strong> to confirm</span>
                <input type="text" name="deleteName" [(ngModel)]="deleteName" autocomplete="off" />
              </label>
              <div class="cf-actions">
                <button type="button" class="btn btn-dark" (click)="confirmDelete = false; deleteName = ''">Keep it</button>
                <button type="button" class="btn btn-dark cf-danger-btn" [disabled]="deleting || deleteName.trim() !== community?.name" (click)="doDelete()">
                  {{ deleting ? 'Deleting…' : 'Delete forever' }}
                </button>
              </div>
            }
          </section>
        }
      }
</app-social-shell>
